<template>
	<label
		class="flex items-center cursor-pointer"
		v-bind="{
			class: $attrs.class,
			tabindex: $attrs.tabindex,
			style: $attrs.style,
		}"
	>
		<input
			ref="checkboxInputRef"
			type="checkbox"
			class="hidden"
			v-bind="{
				...$attrs,
				disabled: $attrs.disabled ? 'disabled' : undefined,
				class: undefined,
				style: undefined,
				tabindex: undefined,
			}"
			v-on="$listeners"
			:checked="isChecked"
			@change="onChange"
		>
		<span class="block w-6 h-6 shrink-0 p-[0.1875rem]">
			<span
				class="w-full h-full border-2 rounded-[0.25rem] flex items-center justify-center"
				:class="[
					!isChecked ? 'bg-transparent' : $attrs.disabled ? 'bg-gray-disabled' : 'bg-primary',
					$attrs.disabled ? 'border-gray-disabled' : 'border-primary',
				]"
			>
				<span class="text-gray-secondary" :class="isChecked ? 'block' : 'hidden'">
					<svg
						class="w-[0.725rem] h-[0.725rem]"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 24 24"
						fill="currentColor"
					>
						<path
							d="M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z"
						/>
					</svg>
				</span>
			</span>
		</span>
		<slot name="label">
			<span
				class="ml-1 leading-[20px] font-medium first-letter:capitalize"
				:class="$attrs.disabled ? 'text-gray-disabled' : 'text-gray-label'"
			>{{label}}</span>
		</slot>
	</label>
</template>

<script>
export default {
	inheritAttrs: false,
	model: {
		prop: 'selected',
		event: 'update:selected',
	},
	props: {
		label: {required: false, type: String, default: ''},
		selected: {required: false},
	},
	computed: {
		isChecked(){
			return this.$attrs['checked'] !== undefined
				? !!this.$attrs['checked']
				: this.selected === this.$attrs['true-value'] || this.selected === this.$attrs['value']
		}
	},
	methods: {
		onChange($event){
			let trueVal = $event.target.value;
			if(this.$attrs['true-value'] !== undefined){
				trueVal = this.$attrs['true-value'];
			}else if(this.$attrs['value'] !== undefined){
				trueVal = this.$attrs['value'];
			}

			const falseVal = this.$attrs['false-value'] === undefined ? null : this.$attrs['false-value'];

			this.$emit(
				'update:selected',
				JSON.stringify(this.selected) === JSON.stringify(trueVal) ? falseVal : trueVal
			);

			this.$emit('change', $event)
		}
	}
}
</script>

<style scoped>

</style>
